import essApi from "../axios/essApi";

class HelpDeskService {
  async getAllSupportTickets(param) {
    return Promise.resolve(essApi.get(`support-request?page=${param?.pageNum}&size=${param?.pageSize}`));
  }

  async getAllSupportTicketsByUserId(param) {
    return Promise.resolve(essApi.get(`support-request-by-user?page=${param?.pageNum}&size=${param?.pageSize}`));
  }

  async deleteSupportTicket(param) {
        return Promise.resolve(essApi.post(`delete-support-ticket`, param));
    }

  

}
export default HelpDeskService;
